import React from 'react';
import { useLocation } from 'react-router-dom';

const JacketsTerms = () => (
  <p>
    <ul style={{ textAlign: 'left', margin: '0', padding: '0' }}>
      <li>Estimated delivery time for all items in Riding jackets is 7 days</li>
      <li>Returns accepted only in case of manufacturing defect</li>
      <li>Only size exchange possible withn 7 days of delivery</li>
      <li>Order once placed cannot be cancelled</li>
      <li>
        Product shown is through creative visualization. Actual final product(s)
        may vary
      </li>
    </ul>
  </p>
);

const TShirtsTerms = () => (
  <p>
    <ul style={{ textAlign: 'left', margin: '0', padding: '0' }}>
      <li>
        This is a custom made t-shirt. Estimated delivery time is 15-20 days
      </li>
      <li>
        Royal Enfield reserves the right to approve or reject any text or other
        user shared content to be added to any of Royal Enfield products
      </li>
      <li>Returns accepted only in case of manufacturing defects</li>
      <li>Order once placed cannot be cancelled</li>
      <li>100% cotton material</li>
      <li>
        Product shown is through creative visualization. Actual final output may
        vary
      </li>
      <li>DO NOT iron on print/embroidery area</li>
    </ul>
  </p>
);

const DefaultTerms = () => (
  <p>
    <ul style={{ textAlign: 'left', margin: '0', padding: '0' }}>
      <li>This is custom made helmet. Estimated delivery time is 30 days</li>
      <li>
        Royal Enfield reserves the right to approve or reject any text or other
        user shared content to be added to any of Royal Enfield products
      </li>
      <li>Returns accepted only in case of manufacturing defects</li>
      <li>Order once placed cannot be cancelled</li>
      <li>
        Respective Helmet weight stands at Open Face 950gm (+ - 50gm) , Full
        Face 1150 (±) 50 grams, Urban Trooper 1100gm (+ - 50gm){' '}
      </li>
      <li>ISI and DOT certified helmets </li>
      <li>
        Product shown is through creative visualization. Actual final output may
        vary
      </li>
    </ul>
  </p>
);

const TermsAndConditions = ({ isLarge }) => {
  const location = useLocation();
  let TermsComponent;
  if (location.pathname.includes('tshirt')) {
    TermsComponent = TShirtsTerms;
  } else if (location.pathname.includes('jacket')) {
    TermsComponent = JacketsTerms;
  } else {
    TermsComponent = DefaultTerms;
  }
  return (
    <div className={`${isLarge ? 'terms-large' : 'terms'}`}>
      <h1>Terms & conditions apply</h1>
      <TermsComponent />
    </div>
  );
};

export default TermsAndConditions;
